import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Can I switch plans at any time?',
      answer: 'Yes! You can upgrade to Pro instantly. Upgrades are prorated, so you only pay for the remaining time in your billing cycle. Downgrades take effect at the end of your current billing period.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards (Visa, Mastercard, American Express) and debit cards. All payments are securely processed through Stripe with bank-level encryption.'
    },
    {
      question: 'Is there a free trial for Pro?',
      answer: 'We offer a 14-day money-back guarantee on Pro subscriptions. If you\'re not satisfied within the first 14 days, we\'ll refund your payment in full, no questions asked.'
    },
    {
      question: 'What happens if I exceed my plan limits?',
      answer: 'If you approach your spending or swap limits, we\'ll notify you via email. You can upgrade to Pro for higher limits, or wait until your limits reset at the start of the next billing cycle.'
    },
    {
      question: 'Are there any hidden fees?',
      answer: 'No hidden fees, ever. All transaction fees, swap fees, and subscription costs are clearly displayed. What you see is what you pay.'
    },
    {
      question: 'How does annual billing work?',
      answer: 'Annual billing gives you 2 months free (17% savings). You pay once per year and enjoy uninterrupted Pro access. You can switch back to monthly billing at renewal time.'
    },
    {
      question: 'Can I cancel my subscription?',
      answer: 'Yes, you can cancel anytime from your subscription management page. Your Pro features remain active until the end of your paid period, then you\'ll automatically move to the Free plan.'
    },
    {
      question: 'What\'s included in Enterprise?',
      answer: 'Enterprise includes custom limits, dedicated support, white-label options, custom integrations, and negotiated pricing. Contact our sales team for a tailored quote based on your needs.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 mb-16">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
        <p className="text-gray-600">Everything you need to know about our pricing and plans</p>
      </div>

      <div className="max-w-3xl mx-auto space-y-4">
        {faqs?.map((faq, index) => (
          <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-50 transition-colors"
            >
              <span className="font-semibold text-gray-900 pr-4">{faq?.question}</span>
              {openIndex === index ? (
                <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" />
              ) : (
                <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" />
              )}
            </button>
            {openIndex === index && (
              <div className="px-5 pb-5 pt-0">
                <p className="text-gray-600 leading-relaxed">{faq?.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="text-center mt-8">
        <p className="text-gray-600 mb-4">Still have questions?</p>
        <a
          href="mailto:support@boltpay.com"
          className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors"
        >
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default FAQSection;